import { LoadingIndicator } from "@/Icons/loadingIndicator";
import { CLIPPED_BUTTON_STYLE } from "@/constants/general";
import { useTrans } from "@/translations";

import { FC } from "react";
import { Link } from "react-router-dom";

import { twMerge } from "tailwind-merge";

export const Button: FC<{
  label: string | React.JSX.Element;
  color?: "primary" | "secondary" | "white" | "black";
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  link?: string;
  clipped?: boolean;
}> = ({
  color = "primary",
  disabled,
  loading,
  label,
  className,
  onClick = () => null,
  type,
  link,
  clipped = true,
}) => {
  const { t } = useTrans();

  const buttonContent = (
    <button
      className={twMerge([
        "disabled:bg-grey1 disabled:text-grey5 h-10 min-w-[164px] flex-none cursor-pointer px-3 text-sm whitespace-nowrap",
        color === "primary" &&
          "bg-lime hover:bg-some-limeish active:bg-saturated-lime",
        color === "secondary" && "bg-grey3 hover:bg-grey2 active:bg-grey4",
        color === "white" &&
          "bg-white hover:bg-neutral-100 active:bg-neutral-200",
        color === "black" &&
          "bg-black fill-white stroke-white text-white hover:bg-neutral-900 active:bg-black",
        className,
        clipped && CLIPPED_BUTTON_STYLE,
      ])}
      onClick={(e) => !loading && onClick(e)}
      disabled={disabled}
      type={type}
    >
      {!loading ? (typeof label === "string" ? t(label) : label) : null}

      {loading && (
        <div className="flex justify-center">
          <LoadingIndicator />
        </div>
      )}
    </button>
  );

  return link ? (
    <Link to={link} target="_blank">
      {buttonContent}
    </Link>
  ) : (
    buttonContent
  );
};
